module.exports = __webpack_public_path__ + "static/media/Change-password.6c6ca8dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/HamburgerIcons/Change-password.svg
// module id = 566
// module chunks = 1